import CustomCard from '../../../components/CustomCard.tsx'
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs'
import { Controller, useFormContext } from 'react-hook-form'
import { HtmlEditor, Link, QuickToolbar, RichTextEditorComponent, Inject, Toolbar, Table, ChangeEventArgs } from '@syncfusion/ej2-react-richtexteditor'
import styles from '../../../styles/components/register.module.scss'

export const QualificationsData = () => {
  const {
    register,
    control,
    setValue,
    formState: { errors },
  } = useFormContext()
  const requiredMsg = 'Dieses Feld ist ein Pflichtfeld'

  const toolbarSettings = {
    items: [
      'FormatPainter',
      'Bold',
      'Italic',
      'Underline',
      'StrikeThrough',
      'SuperScript',
      'SubScript',
      '|',
      'FontName',
      'FontSize',
      'FontColor',
      'BackgroundColor',
      'LowerCase',
      'UpperCase',
      '|',
      'Formats',
      'Alignments',
      'OrderedList',
      'UnorderedList',
      '|',
      'Outdent',
      'Indent',
      '|',
      'CreateLink',
      'Image',
      'CreateTable',
      '|',
      'SourceCode',
      'Undo',
      'Redo',
    ],
  }

  const handleOnChange = (fieldName: string, args: ChangeEventArgs) => {
    setValue(fieldName, args.value)
  }

  return (
    <CustomCard header="Qualifizierung, Erfahrung, Publikationen">
      <TextBoxComponent placeholder="Aktuelle berufliche Stellung" cssClass={`${styles.required}`} floatLabelType="Always" {...register('position', { required: requiredMsg })} />
      <p className="errorMsg"> {(errors.position?.message as string) || null}</p>

      <TextBoxComponent placeholder="Fachliche Kompetenzbereich(e)" cssClass={`${styles.required}`} floatLabelType="Always" {...register('profCompetencies', { required: requiredMsg })} />
      <p className="errorMsg"> {(errors.profCompetencies?.message as string) || null}</p>

      <TextBoxComponent placeholder="Berufsausbildung, Studium, relevante Zertifizierungen" cssClass={`${styles.required}`} floatLabelType="Always" {...register('lifeCareer', { required: requiredMsg })} />
      <p className="errorMsg">{(errors.lifeCareer?.message as string) || null}</p>

      <p style={{ marginTop: '20px', position: 'relative' }}>
        Lehrerfahrungen<span className={styles.asterik}>*</span>
      </p>
      <Controller
        control={control}
        name="teachingExperience"
        rules={{ required: requiredMsg }}
        render={({ field }) => (
          <RichTextEditorComponent
            value={field.value}
            cssClass={`${styles.required}`}
            height={350}
            toolbarSettings={toolbarSettings}
            enableXhtml={true}
            change={(e) => {
              field.onChange(e.value)
              handleOnChange('teachingExperience', e)
            }}
          >
            <Inject services={[HtmlEditor, QuickToolbar, Toolbar, Link, Table]} />
          </RichTextEditorComponent>
        )}
      />
      <p className="errorMsg">{(errors.teachingExperience?.message as string) || null}</p>

      <p style={{ marginTop: '30px', position: 'relative' }}>
        Kurzlebenslauf für die Webseite im Fließtext mit max. 10 Zeilen (MUSTER)<span className={styles.asterik}>*</span>
      </p>
      <Controller
        control={control}
        name="vita"
        rules={{ required: requiredMsg }}
        render={({ field }) => (
          <RichTextEditorComponent
            value={field.value}
            cssClass={`${styles.required}`}
            height={350}
            toolbarSettings={toolbarSettings}
            enableXhtml={true}
            change={(e) => {
              field.onChange(e.value)
              handleOnChange('vita', e)
            }}
          >
            <Inject services={[HtmlEditor, QuickToolbar, Toolbar, Link, Table]} />
          </RichTextEditorComponent>
        )}
      />
      <p className="errorMsg">{(errors.vita?.message as string) || null}</p>
    </CustomCard>
  )
}
